import React, { useEffect, useState } from "react";
import { getLeadTimes } from "../../../views/Dashboard/WindowDoor/LeadTimes/api";
import WidgetFrame, { WidgetEmpty } from "./WidgetFrame";

// "2026-07-20" -> "Jul 20"; falls through for free-text values.
const prettyDate = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  if (!m) return value || "—";
  return new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
};

const changeCount = (brand) =>
  (brand.sections || []).reduce(
    (total, section) =>
      total +
      (section.items || []).filter(
        (item) => item.was && item.now && item.was !== item.now
      ).length,
    0
  );

// Compact lead-times summary: the most recently updated brands and how many
// products moved in each brand's latest update.
const LeadTimesWidget = () => {
  const [brands, setBrands] = useState(null);

  useEffect(() => {
    getLeadTimes()
      .then((data) => setBrands(Array.isArray(data) ? data : []))
      .catch(() => setBrands([]));
  }, []);

  if (brands === null) {
    return (
      <WidgetFrame title="Window Lead Times" to="/windowdoor/lead-times">
        <WidgetEmpty>Loading lead times…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const recent = [...brands]
    .sort((a, b) =>
      String(b.effectiveDate || "").localeCompare(String(a.effectiveDate || ""))
    )
    .slice(0, 4);

  return (
    <WidgetFrame title="Window Lead Times" to="/windowdoor/lead-times">
      {recent.length > 0 ? (
        <ul className="space-y-1.5">
          {recent.map((brand) => {
            const changes = changeCount(brand);
            return (
              <li
                key={brand.brandKey || brand.brand}
                className="flex items-center justify-between gap-2 text-sm"
              >
                <span className="truncate font-medium">{brand.brand}</span>
                <span className="app-muted shrink-0 text-xs">
                  {prettyDate(brand.effectiveDate)}
                  {changes > 0 && (
                    <span className="ml-1.5 rounded-full bg-amber-500/15 px-1.5 py-0.5 font-semibold text-amber-700 dark:text-amber-300">
                      {changes} changed
                    </span>
                  )}
                </span>
              </li>
            );
          })}
        </ul>
      ) : (
        <WidgetEmpty>No lead times published yet.</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default LeadTimesWidget;
